
import { defineComponent, computed } from "vue";
import { RevenueDashboardState } from "@/domain/entities/RevenueDashboard";
import formatPriceRP from '@/app/infrastructures/misc/common-library/v2/FormatPriceRP';
import { AccountController } from '@/app/ui/controllers/AccountController';

export default defineComponent({
  name: "CardTotalProfit",
  props: {
    data: {
      type: RevenueDashboardState,
      default: () => new RevenueDashboardState()
    }
  },
  emits: ["refresh"],
  setup(props, { emit }) {
    const onRefresh = () => emit("refresh");

    const accountCurrency = computed(() => {
      return (
        (AccountController.accountData?.accountCurrency as "IDR" | "MYR") ??
        "IDR"
      );
    });

    return {
      ...props,
      formatPriceRP: formatPriceRP,
      onRefresh,
      accountCurrency
    };
  }
});
